import React from 'react'
import {FormControl, FormHelperText, FormLabel} from '@material-ui/core';
import getObjectValue from 'libs/getObjectValue'
import Tr from 'translations/Translations';
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import {makeStyles} from "@material-ui/styles";

const useStyle = makeStyles(theme => ({
    button: {
        width: 150
    },
    toggle: {
        marginTop: theme.spacing()
    }
}))

function YesNo(
    {
        formikProps,
        id,
        label,
        disabled,
        className,
        required,
        noError,
        onChange = () => {
        },
        skipCheckTouched
    }) {
    const classes = useStyle();
    const value = getObjectValue(id, formikProps.values, null)
    const errorValue = getObjectValue(id, formikProps.errors, '')
    const touched = getObjectValue(id, formikProps.touched, !!skipCheckTouched)
    const editable = getObjectValue('_editable', formikProps.values, true);

    const isError = !noError && (!!errorValue && touched)

    const helperText = (isError && errorValue) || ' ';

    let _label = label;
    if (required) _label += '*';

    return <div data-id={id}>
        <FormControl
            disabled={!editable}
            error={isError}
            className={className}>
            <FormLabel>{_label}</FormLabel>
            <ToggleButtonGroup className={classes.toggle} size="small" value={value} exclusive onChange={(event, newProcedure) => {
                formikProps.setFieldValue(id, newProcedure)
                onChange(newProcedure)
            }}>
                <ToggleButton classes={{root: classes.button}} value={true} disabled={!editable || disabled}>
                    {Tr('yes')}
                </ToggleButton>
                <ToggleButton classes={{root: classes.button}} value={false} disabled={!editable || disabled}>
                    {Tr('no')}
                </ToggleButton>
            </ToggleButtonGroup>
            <FormHelperText className={classes.error}>{helperText}</FormHelperText>
        </FormControl>
    </div>

}

export default YesNo
